import { CloudFog, Footprints, Fuel, Mountain, Ship, WifiOff } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { dictionaries } from "../lib/i18n";
import type { UiLang } from "../lib/types";

/**
 * Hvorfor en vanlig reiseplan ryker i Norge.
 *
 * Siden gikk rett fra overskriften til kontrollpanelet: velg rute, velg dager,
 * trykk. Det er riktig for den som allerede vet hva appen er til for, og den
 * som ikke gjør det, ser en dag-for-dag-generator til — det finnes hundre av
 * dem, og de fleste er en liste over severdigheter med datoer på.
 *
 * Kortene her sier hva forskjellen er, og de sier det med de faktiske
 * beskrankningene: en tolv timers fottur, en ferje man ikke rekker, en
 * fjellovergang som er kolonnekjørt. En tilreisende vet ikke at hun må tenke
 * på dem — det er hele grunnen til at appen gjør det.
 *
 * Seks korte kort, ikke seks avsnitt markedstekst. Hvert av dem peker på noe
 * appen faktisk gjør, og hvert av dem er kortet ned til den ene setningen som
 * gjør at man kjenner seg igjen i problemet.
 */

const ICONS: LucideIcon[] = [CloudFog, Footprints, Ship, Mountain, Fuel, WifiOff];

interface Props {
  lang: UiLang;
}

export function WhyItinerariesBreak({ lang }: Props) {
  const t = dictionaries[lang];

  return (
    <section className="why no-print" aria-labelledby="why-title">
      <h2 className="why-title" id="why-title">
        {t.whyTitle}
      </h2>
      <p className="why-lede">{t.whyLede}</p>

      <ul className="why-cards">
        {t.whyCards.map((card, index) => {
          const Icon = ICONS[index] ?? CloudFog;
          return (
            <li className="why-card" key={card.title}>
              <span className="why-icon" aria-hidden="true">
                <Icon size={17} />
              </span>
              <h3>{card.title}</h3>
              <p>{card.body}</p>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
